import { useGet } from './templateHooks';
import { MagicBellHMACKey } from 'src/@types/magicbell';

export const useMagicBellHMACKey = () =>
  useGet<MagicBellHMACKey>({
    queryKey: ['magicbell', 'hmacKey'],
    endpoint: '/v1/magicbell-hmac-key',
  });
